import React, { Component } from 'react'
import MenuVistaContact from '../MenuVistaFriend/MenuVistaFriend'

export default class PendingAccept extends Component {
		
	state = {
	}

	render() {
		const { personList, updateUsers, lang } = this.props
		
		return (
            <div className="main-pendingaccept">
				{personList && (personList.length>0) && personList.map((item, k)=>{
					return (
						<div className='box-user-firend' key={`item-user-contact_${k}`}>
							<MenuVistaContact updateUsers={updateUsers} type="pendingAccept" userData={item} lang={lang}  />
						</div>
					)
				})}
            </div>
        );
	}
}
